import styles from "./TitleLayout.module.css";
import PressEnterSvg from "../object-graphics/PressEnterSvg";
import UseArrowsToMoveSvg from "../object-graphics/UseArrowsToMoveSvg";
import { useKeyPress } from "../../hooks/useKeyPress";

export default function TitleHowToPlay({ onEnter }) {
  useKeyPress("Enter", () => {
    onEnter();
  });
  return (
    <div className={styles.container}>
      <div className={styles.containerInner}>
        <UseArrowsToMoveSvg />
        <div className={styles.pressEnterContainer}>
          <button
            onClick={() => {
              onEnter();
            }}
          >
            <PressEnterSvg />
          </button>
        </div>
      </div>
    </div>
  );
}
